const SUBJECT_MAX_QUESTION_COUNT = {
  suri: 20,
  churi: 30,
}

export default SUBJECT_MAX_QUESTION_COUNT
